import { HttpInterceptorFn } from '@angular/common/http';
import { BASE_API_URL } from '../../constants/api-url';
import { HTTP_HTTPS_REGEX } from '../../constants/system-constants.model';

export const ApiPrefixInterceptor: HttpInterceptorFn = (request, next) => {
  if (!HTTP_HTTPS_REGEX.test(request.url)
    && !request.url.includes('assets/'))
    request = request.clone({ url: BASE_API_URL + request.url });
  return next(request);
};
